import { connect } from 'react-redux';
import { compose } from 'redux';

import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import { BucketState, BucketDispatch } from 'src/types/state';

import { fetchRepositorySubscriptions } from '../actions';
import toggleRepositoryWatch from '../actions/toggle-repository-watch';
import SubscriptionsModalDialog from '../components/subscriptions-modal-dialog';
import { WatchPrefs } from '../types';

const mapStateToProps = (state: BucketState) => ({
  hasError: state.repository.subscriptions.hasError,
  isWatchingRepository: state.repository.details.isWatching,
  repositoryFullSlug: getCurrentRepositoryFullSlug(state),
  settings: state.repository.subscriptions.settings,
});

const mapDispatchToProps = (dispatch: BucketDispatch) => ({
  onFetchRepositorySubscriptions: (
    repositoryFullSlug: string,
    settings?: WatchPrefs
  ) => dispatch(fetchRepositorySubscriptions(repositoryFullSlug, settings)),
  onToggleRepositoryWatch: (repositoryFullSlug: string) => {
    dispatch(toggleRepositoryWatch(repositoryFullSlug));
  },
});

export default compose<any>(connect(mapStateToProps, mapDispatchToProps))(
  SubscriptionsModalDialog
);
